import type { UnionTypeLibelle } from '../../techniques'

export const Permanent = 'Permanent' as const
export const Interimaire = 'Interimaire' as const

export type Permanent = typeof Permanent
export type Interimaire = typeof Interimaire

export const TypePublic = [Permanent, Interimaire] as const

export type TypePublic = (typeof TypePublic)[number]

export const TypePublicLibelle: UnionTypeLibelle<TypePublic> = {
  Permanent: 'Permanent',
  Interimaire: 'Intérimaire',
} as const
